import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND } from '../../data/site';
interface LogoMarkProps {
  /** Renders as a link to the home page unless `asText` is set. */
  asText?: boolean;
  tone?: 'light' | 'dark';
}

/**
 * Logo image plus wordmark. The image is decorative because the brand name
 * sits beside it as real text — alt text here would be read twice.
 */
export function LogoMark({
  asText = false,
  tone = 'dark'
}: LogoMarkProps) {
  const nameColour = tone === 'light' ? 'text-cream' : 'text-ink';
  const descriptorColour = tone === 'light' ? 'text-cream-muted' : 'text-ink-muted';
  const content = <>
      <img src={BRAND.logoUrl} alt="" aria-hidden="true" width={40} height={40} loading="eager" className="h-9 w-9 shrink-0 object-contain sm:h-10 sm:w-10" data-id="element-140" data-mp="26gl65kxjryh1" />
      <span className="flex min-w-0 flex-col leading-none" data-id="element-141" data-mp="c56euzow1qz6">
        {/* nowrap: the full name is four words and the header carries six
            nav items beside it — allowed to wrap, it breaks to two lines
            and pushes the header taller at exactly the widths where the
            nav is already tightest. */}
        <span className={`whitespace-nowrap font-bebas text-xl tracking-wide sm:text-2xl ${nameColour}`} data-id="element-142" data-mp="130s3k9vj9khp">
          {BRAND.name}
        </span>
        <span className={`hidden text-[10px] font-bold uppercase tracking-[0.18em] sm:block ${descriptorColour}`} data-id="element-143" data-mp="17sjjzrkz69u4">
          {BRAND.shortDescriptor}
        </span>
      </span>
    </>;
  if (asText) {
    return <div data-component-id="C13" className="flex items-center gap-2.5" data-id="element-144" data-mp="1moshoop7wf4f">
        {content}
      </div>;
  }
  return <Link data-component-id="C13" to="/" className="flex items-center gap-2.5 rounded-control focus:outline-none focus:ring-2 focus:ring-moss focus:ring-offset-2" data-id="element-145" data-mp="1qqdy2k0ynbjd">
      <span className="sr-only" data-id="element-146" data-mp="3sgxwm97vsvxt">{BRAND.name}, back to the home page</span>
      {content}
    </Link>;
}